import { COMPANY_SENDING_REQUEST, COMPANY_DETAIL_SUCCESS, COMPANY_REQUEST_FAIL } from "../action-types/company"

const initCompany = {
    loading: false,
    message: "",
    successStatus: false,
    company: null,
}

export default function companyReducer(state = initCompany, action) {
    switch (action.type) {
        case COMPANY_SENDING_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case COMPANY_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                company: action.payload,
                successStatus: true,
            }
        case COMPANY_REQUEST_FAIL: {
            return {
                ...state,
                loading: false,
                message: action.payload,
            }
        }
        default:
            return state
    }
}
